import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';

class ProtectedRoute extends React.Component {
  shouldComponentUpdate(nextProps) {
    return !(
      this.props.personal.condition === nextProps.personal.condition
      && this.props.loggedIn === nextProps.loggedIn
      && this.props.component === nextProps.component
    );
  }

  render() {
    const {
      personal, loggedIn, component: Component, isProfileRequired = false, notRegistered, ...rest
    } = this.props;
    if (
      !(personal.condition || loggedIn)
      || (isProfileRequired && (!personal.patient_id || !personal.profile_id))
      || (notRegistered && personal.user_wix_id)
    ) {
      return <Redirect to={ROUTE_PATH[ROUTE_NAME.HOME]} />;
    }

    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }
}

const mapStateToProps = (state) => ({
  personal: state.profile.data?.personal?.condition ? state.profile.data.personal : false,
  loggedIn: !!(state.authentication && state.authentication.loggedIn && state.authentication.user),
});

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  isProfileRequired: PropTypes.bool,
  notRegistered: PropTypes.bool,
  personal: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  loggedIn: PropTypes.bool,
};

export default withRouter(connect(mapStateToProps)(ProtectedRoute));
